import React, { useEffect, useState } from "react";
import "./TestLivekit.css";
import { ConnectionCheck } from "livekit-client";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getTestToken } from "../../../MediaPlayback/store/livekitSlice/livekitThunks";
import { unwrapResult } from '@reduxjs/toolkit';
import { apiThunkForSupportModal } from "../../store/apiThunkForSupportModal";
import {
    Button,
    DialogActions,
} from "@mui/material";
const TestLivekit = ({ onClose }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const{
        livekitUrl,
        localAvatar
    } = useSelector((state) => state.auth);
    
    const SuccessIcon = () => <span style={{ color: "green" }}>✔</span>;
    const FailIcon = () => <span style={{ color: "red" }}>✖</span>;
    const LoadingIcon = () => <span style={{ color: "gray" }}>⏳</span>;
    const steps = [
        { key: "websocket", title: "websocket_test" },
        { key: "webrtc", title: "webrtc_test" },
        { key: "turn", title: "turn_test" },
        { key: "publishAudio", title: "publishAudio_test" },
        { key: "publishVideo", title: "publishVideo_test" },
        { key: "connectionProtocol", title: "connectionProtocol_test" },
      ];
      
    
      const [results, setResults] = useState({});
      const [currentStep, setCurrentStep] = useState(0);
      const progress = Math.floor((currentStep / steps.length) * 100);
      const [overallSuccess, setOverallSuccess] = useState(null); // null = running, true/false = finished
      const [anyError, setAnyError] = useState(false);
      const [title, setTitle] = useState("Test Livekit");
      const [description, setDescription] = useState("");
      const [error, setError] = useState();
      const [success, setSuccess] = useState();

      
      const domain = window.location.hostname;
      let formattedSubDomain = "";
      let subDomain = "";
      if (
        domain.indexOf(".") < 0 ||
        domain.split(".")[0] === "example" ||
        domain.split(".")[0] === "lvh" ||
        domain.split(".")[0] === "www"
    ) {
        subDomain = "";
    } else {
        subDomain = domain.split(".")[0];
    }
    function isPrivateIP(ip) {
        return (
            ip.startsWith("10.") ||
            ip.startsWith("172.") && parseInt(ip.split(".")[1]) >= 16 && parseInt(ip.split(".")[1]) <= 31 ||
            ip.startsWith("192.168.") ||
            ip === "127.0.0.1"
        );
    }


    if (/*LOCAL || */ domain.startsWith("localhost") || isPrivateIP(domain)) {
        subDomain = "dev";
    }
    if (subDomain) {
        formattedSubDomain = subDomain.charAt(0).toUpperCase() + subDomain.slice(1);
    }
const handleSubmit = async () => {
    if (!title) {
        setError(t('form_title_required'));

        return;
    }
    if (!description) {
         setError(t('form_description_required'));
        return;
    }
    try {
        const ticketTitle = title.startsWith(`[${formattedSubDomain}][Aifel]`)
            ? title
            : `[${formattedSubDomain}][Aifel] ${title}`;
        const fullDescription = `${description}`;
        let formData = null;
        const resultAction = await dispatch(
            apiThunkForSupportModal({
                ticketTitle,
                fullDescription,
                formData
            })
        );
        unwrapResult(resultAction);
        setSuccess(t('support_request_success'));
        setTimeout(() => {
            onClose();
        }, 1500);

    } catch (err) {
        console.error("[SupportModal Error]", err);

        // ✅ Affiche l'erreur utilisateur
          setError(t('support_ticket_error'));
        setTimeout(() => {
            setError(null);
        }, 5000);
    }
};



    useEffect(() => {
        let isActive = true;
        const runLiveKitTest = async (url, token) => {
            const tester = new ConnectionCheck(url, token);
            const stepResults = {};
      
            const stepFuncs = [
              async () => { stepResults.websocket = await tester.checkWebsocket(); },
              async () => { stepResults.webrtc = await tester.checkWebRTC(); },
              async () => { stepResults.turn = await tester.checkTURN(); },
              async () => { stepResults.publishAudio = await tester.checkPublishAudio(); },
              async () => { stepResults.publishVideo = await tester.checkPublishVideo(); },
              async () => { stepResults.connectionProtocol = await tester.checkConnectionProtocol(); },
            ];
      
            for (let i = 0; i < stepFuncs.length; i++) {
              if (!isActive) {
                console.log("Test stopped because modal closed");
                break;
              }
              await stepFuncs[i]();
              setResults(prev => ({ ...prev, ...stepResults }));
              setCurrentStep(i + 1);
            }
            const success = tester.isSuccess();
            setOverallSuccess(success);
          
            // Check if any step failed
            const hasError = Object.values(stepResults).some(r => r?.status !== 3);
            setAnyError(hasError);
            setDescription(JSON.stringify(stepResults, null, 2));
          };

      
        const startTest = async() => {
          try {
            const testToken = await dispatch(getTestToken()).unwrap();
      
            if (testToken && isActive) {
              await runLiveKitTest(livekitUrl, testToken);
            }
          } catch (err) {
            console.error("LiveKit test failed:", err);
          }
        };
        startTest();
        return () => { isActive = false; };
      }, []);
      

      return (
        <div className="test-container" >
          {/* Progress Bar */}
          {overallSuccess === null && (
              <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{ width: `${progress}%` }}
            />
          </div>
          )}
          
          {/* Overall result display */}
                {overallSuccess !== null && (
                <div style={{ marginBottom: 20 }}>
                    <strong>
                    {t("test_result")}{" "}
                    <span style={{ color: overallSuccess ? "green" : "red" }}>
                        {t(overallSuccess ? "success" : "failed")}
                    </span>
                    </strong>
                </div>
                )}

                

          <div className="test-results">  
          {steps.map((step, index) => {
            const result = results[step.key];
      
            let icon = <LoadingIcon />;
            if (result) {
              icon = result.status === 3 ? <SuccessIcon /> : <FailIcon />;
            }
      
            return (
              <div key={step.key} className="test-block">
                <h5 style={{ 
                    display: "flex", 
                    alignItems: "center",
                    gap: 10,
                    color: !result && index === currentStep
                    ? "gray"          // running
                    : result?.status === 3
                    ? "green"         // success
                    : result
                    ? "red"           // failed
                    : "black"   
                    }}>
                  {icon} {t(step.title)}
                </h5>
      
                {/* Logs after step finishes */}
                {result && (
                <div className="logs-box">
                    {Array.isArray(result.logs) && result.logs.length > 0 ? (
                    result.logs.map((log, i) => (
                        <div key={i} className={`log-line log-${log.level}`}>
                        {log.message}
                        </div>
                    ))
                    ) : (
                    <div className="log-line">{t("no_logs")}</div>
                    )}
                </div>
                )}

      
                {/* Loading while running */}
                {!result && index === currentStep && (
                  <div style={{ color: "#777" }}>{t("running_test")}</div>
                )}
              </div>
            );
          })}
          
          </div>
          {/* Button to show full results if any step failed */}
          {anyError && overallSuccess !== null && (
                <DialogActions>
                 <Button className="send-test-result"  sx={{
              color: "white !important",
              borderRadius: "0.5rem",
              background: 'var(--peoplmap-primary)',
              display: "flex",
              padding: "0.6875rem 1.375rem",
              justifyContent: "center",
              alignItems: "center",
              textTransform: "none",
              '&:hover': {
                background: "#53c03d",
              }
            }} onClick={handleSubmit}  > {t("send_report")}</Button>
             </DialogActions>
                )}
        </div>
      );
      
};
export default TestLivekit;